// Indice degli ingredienti: il campo di ricerca nasconde gli ingredienti che
// non corrispondono, e le lettere rimaste vuote. Accenti ignorati: "lamponi"
// trova anche "Lampòni".
const plain = (text) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

export function setupIngredientFilter() {
  const index = document.querySelector('[data-ingredient-index]');
  if (!index) return;
  const input = index.querySelector('[data-ingredient-search]');
  const none = index.querySelector('[data-ingredient-none]');
  const sections = [...index.querySelectorAll('.ingredient-index__letter')];
  const items = sections.map((section) =>
    [section, [...section.querySelectorAll('li')].map((li) => [li, plain(li.dataset.name || '')])]
  );

  input.addEventListener('input', () => {
    const query = plain(input.value);
    let found = false;
    items.forEach(([section, lis]) => {
      let visible = 0;
      lis.forEach(([li, name]) => {
        const match = !query || name.includes(query);
        li.hidden = !match;
        if (match) visible += 1;
      });
      section.hidden = visible === 0;
      if (visible) found = true;
    });
    none.hidden = found;
  });
}
